package me.repeater64.advancedmpkeditor.util

fun prettyPrintDataClass(input: Any, indentStep: String = "    ") {
    println(getPrettyPrintedDataClass(input, indentStep))
}

fun getPrettyPrintedDataClass(input: Any, indentStep: String = "    "): String {
    val sb = StringBuilder()
    var level = 0

    val trimInput = input.toString().trim()
    var i = 0
    while (i < trimInput.length) {
        val char = trimInput[i]

        when (char) {
            '(', '[', '{' -> {
                level++
                sb.append(char).append("\n").append(indentStep.repeat(level))
            }
            ')', ']', '}' -> {
                level--
                sb.append("\n").append(indentStep.repeat(level)).append(char)
            }
            ',' -> {
                sb.append(char).append("\n").append(indentStep.repeat(level))
                // Skip the space that usually follows a comma in toString()
                if (i + 1 < trimInput.length && trimInput[i + 1] == ' ') i++
            }
            else -> sb.append(char)
        }
        i++
    }
    return sb.toString()
}

fun mapIntToAlpha(n: Int): String {
    if (n < 0) throw IllegalArgumentException("Input must be non-negative")

    val result = StringBuilder()
    var num = n

    do {
        val remainder = num % 26
        result.append('a' + remainder)

        num = (num / 26) - 1
    } while (num >= 0)

    return result.reverse().toString()
}

fun hash(vararg values: Any?): Int {
    return values.fold(0) { acc, value ->
        31 * acc + (value?.hashCode() ?: 0)
    }
}